import { withPath } from 'infrastructure/menu';
import Content from './Content';

export default withPath(Content);
